import { SVGProps } from "react";
import { Interpolation, Theme } from "@emotion/react";

export const ContentTextType = ({
  focused,
  ...props
}: SVGProps<SVGSVGElement> & {
  focused?: boolean;
  css?: Interpolation<Theme>;
}) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask id="path-1-inside-1_1686_20024" fill="white">
        <rect width="20" height="4" rx="0.5" />
      </mask>
      <rect
        width="20"
        height="4"
        rx="0.5"
        fill={focused ? "#333333" : "#CCCCCC"}
        stroke={focused ? "#333333" : "#CCCCCC"}
        strokeWidth="3"
        mask="url(#path-1-inside-1_1686_20024)"
      />
      <mask id="path-2-inside-2_1686_20024" fill="white">
        <rect y="8" width="20" height="4" rx="0.5" />
      </mask>
      <rect
        y="8"
        width="20"
        height="4"
        rx="0.5"
        fill={focused ? "#333333" : "#CCCCCC"}
        stroke={focused ? "#333333" : "#CCCCCC"}
        strokeWidth="3"
        mask="url(#path-2-inside-2_1686_20024)"
      />
      <mask id="path-3-inside-3_1686_20024" fill="white">
        <rect y="16" width="20" height="4" rx="0.5" />
      </mask>
      <rect
        y="16"
        width="20"
        height="4"
        rx="0.5"
        fill={focused ? "#333333" : "#CCCCCC"}
        stroke={focused ? "#333333" : "#CCCCCC"}
        strokeWidth="3"
        mask="url(#path-3-inside-3_1686_20024)"
      />
    </svg>
  );
};
